import React, { useEffect } from 'react';
import { Box } from '@mui/material';

import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidButton } from "components/buttons/SolidButton";

const BottomActionBar = ({ parentId, show, onCheckFormValid, onCancel, onApply }) => {

  useEffect(() => {
    const parentElement = document.getElementById(parentId);
    const bottomActionBarElement = document.getElementById("bottomActionBar");

    if (parentElement && bottomActionBarElement) {
      const resizeObserver = new ResizeObserver(() => {
        const parentWidth = parentElement.clientWidth;
        bottomActionBarElement.style.width = `${parentWidth - 32}px`;
      });
      resizeObserver.observe(parentElement);

      const parentWidth = parentElement.clientWidth;
      bottomActionBarElement.style.width = `${parentWidth - 32}px`;

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [parentId]);

  useEffect(() => {
    const bottomActionBarElement = document.getElementById("bottomActionBar");
    if (show) {
      bottomActionBarElement.style.transform = "translateY(20px)";
      bottomActionBarElement.style.transition = "transform 0.3s ease-in-out";
    } else {
      bottomActionBarElement.style.transform = "translateY(80px)";
    }
  }, [show]);

  return (
    <Box
      id="bottomActionBar"
      sx={{
        position: "fixed",
        bottom: "20px",
        width: 0,
        display: show ? "flex" : "none",
        justifyContent: "center",
        gap: 2,
        margin: "16px 0",
        padding: "16px",
        backgroundColor: "primary.lightBlue",
        transform: "translateY(80px)",
      }}
    >
      <OutlineButton
        onClick={onCancel}
        sx={{ marginRight: "20px" }}
        width="100px"
        height="32px"
      >
        Cancel
      </OutlineButton>
      <SolidButton
        onClick={onApply}
        width="100px"
        height="32px"
        disabled={!onCheckFormValid()}
      >
        Apply
      </SolidButton>
    </Box>
  );
};

export default BottomActionBar;